exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-page-wrapper .header-wrapper {\n  background-color: white !important;\n}", ""]);

// exports
